import React from 'react';

interface Props {
  children: React.ReactNode;
  offerCount: number;
  onViewMoreOffer: () => void;
}

function CustomerSelectedOffer({
  children,
  offerCount,
  onViewMoreOffer,
}: Props) {
  const moreOfferCount = offerCount - 1;

  return (
    <>
      <div className="offers-header">
        {/* eslint-disable-next-line react/no-unescaped-entities */}
        <h3 className="title">Customer's Selected Offer</h3>
        <div onClick={onViewMoreOffer} className="collapse-expand-offers-btn">
          View {moreOfferCount} More Finance Offer{moreOfferCount !== 1 && 's'}
        </div>
      </div>
      <div className="lending-offers-row">
        <div className="lending-offer-wrapper">{children}</div>
      </div>
    </>
  );
}

export default CustomerSelectedOffer;
